module.exports = __webpack_public_path__ + "static/media/gatling.449c44eb.mp3";